/**
 * Normalise la liste des `dirType` renvoyée par l’API.
 * Le COMEX est géré comme une équipe : on ne l’expose pas comme type rattachable.
 */
const COMEX_DIR_TYPE = 'COMEX'

export const COMEX_MANAGED_AS_TEAM_ERROR =
  'Le COMEX est géré comme une équipe. Impossible d’y rattacher une direction.'

export function isComexDirType(dirType: string | null | undefined): boolean {
  return (dirType ?? '').trim().toLowerCase() === COMEX_DIR_TYPE.toLowerCase()
}

export function isForbiddenComexDirTypeAssignment(
  dirLib: string | null | undefined,
  dirType: string | null | undefined
): boolean {
  if (!isComexDirType(dirType)) return false
  return (dirLib ?? '').trim().toLowerCase() !== COMEX_DIR_TYPE.toLowerCase()
}

export function withoutComexDirTypes(dirTypes: readonly string[]): string[] {
  return dirTypes.filter((dirType) => !isComexDirType(dirType))
}

export function normalizeDirTypes(raw: unknown): string[] {
  if (!Array.isArray(raw)) return []
  const seen = new Set<string>()
  const dirTypes: string[] = []
  for (const item of raw) {
    if (typeof item !== 'string') continue
    const value = item.trim()
    if (!value || seen.has(value)) continue
    seen.add(value)
    dirTypes.push(value)
  }
  return withoutComexDirTypes(dirTypes)
}

/** Types assignables à partir d’un index `{ [dirType]: directions[] }`. */
export function dirTypesFromGroupedRecord(raw: unknown): string[] {
  if (raw === null || typeof raw !== 'object' || Array.isArray(raw)) {
    return []
  }
  return normalizeDirTypes(Object.keys(raw))
}
